import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';
import { useEffect } from 'react';
import type { RefObject } from 'react';
import { onLoad, waitUntilReady } from '../../../utils/onLoadTracking';

export const useTrackOnload = (
  imgref: RefObject<HTMLImageElement | null>,
  {
    field_onload_tracking_name: onloadTrackingName,
    field_onload_tracking_key: onloadTrackingKey,
    field_onload_tracking_value: onloadTrackingValue,
  }: {
    field_onload_tracking_name?: string | null;
    field_onload_tracking_key?: string | null;
    field_onload_tracking_value?: string | null;
  },
) => {
  const dispatchGTMEvent = useTracking();
  /**
   * If tracking params are set, fire the event once the image is loaded (complete) and
   * the dataLayer is ready
   */
  useEffect(() => {
    if (onloadTrackingName && onloadTrackingKey && onloadTrackingValue) {
      waitUntilReady(
        () => (window as any).dataLayer && imgref.current?.complete,
        () =>
          onLoad('trackFooterImageLoad', dispatchGTMEvent, {
            onloadTrackingName,
            onloadTrackingKey,
            onloadTrackingValue,
          }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatchGTMEvent]);
};
